export default [
	"dashboard",
	"stream rating",
	"users",
	"streamers",
	"playlist",
	"channel list",
	"logs",
	"pulse",
	"errors",
	"subscribers",
	"operators",
	"regions",
	"admins"
];

// "user list": 'subscriberList',
// "user": 'subscriber',
// "auth history": 'subscriberAuthHistory',
// "balancer history": 'subscriberViewHistory',
// "full user history": 'fullSubscriberActionsHistory',
// "session history": 'sessionHistory',
// "Stream's view rating": 'streamViewRating',
// "Video errors rating last 24h": 'videoErrorsRatingLast24h',
// "Flussonic Pulse": 'flussonicPulse'






// WEBPACK FOOTER //
// ./src/script/optionMenu.js